import { render, staticRenderFns } from "./discus-3.vue?vue&type=template&id=807cfb4c&scoped=true&"
import script from "./discus-3.vue?vue&type=script&lang=js&"
export * from "./discus-3.vue?vue&type=script&lang=js&"
import style0 from "./discus-3.vue?vue&type=style&index=0&id=807cfb4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807cfb4c",
  null
  
)

export default component.exports